import { THEME_IDS } from "./theme-ids";

export const isThemeId = (v: unknown): v is string => typeof v === "string" && THEME_IDS.includes(v);
